<!--
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-11-22 00:07:12
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-12-01 16:31:56
 * @FilePath: \H5\src\views\bottom.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  <div class="button">
    <div class="left">
      <img src="../assets/images/底部右侧按钮.png" alt="">
      <div class="f-box" @click="hTil">
        <div class="phone">
        <img src="../assets/images/电话.png" alt="" style="width: 100%; height: 100%;">
      </div>
      <div>客服</div>
      </div>
    </div>
    <div class="right" @click="hGo">
      <img src="../assets/images/底部左侧按钮.png" alt="">
      <div class="r-text">
        去店铺逛逛
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      list: null,
      phone: ''
    };
  },
  created() {
    this.list = JSON.parse(
      window.localStorage.getItem("reData"))
    this.phone = this.list.phone
    console.log(this.phone);
  },
  methods: {
    hTil() {
      window.location.href = 'tel:' + this.phone
      
    },
     async hGo() {
      let data = {
        merchant_id: this.list.wx_merchant_id,
        path: `pages/index/welcome?product=${ this.list.product_id }&ag=0&m_id=${ this.list.model_id }&merchant_id=${ this.list.merchant_id }`
      }
      await axios.post(
        'https://apigateway.klyun.com.cn/chaintea/industry/v1.0.0/api/myshop/CreateWXScheme',
         data
      ).then(res => {
        console.log(res.data);
        if(res.data.message.code === 200) {
          location.href = res.data.data.openlink
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  width: 486px;
  height: 82px;
  left: 10%;
  display: flex;
  position: fixed;
  bottom: 10px;
  z-index: 1;
  margin: 0 auto;
  .left {
    .f-box {
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #127855;
      opacity: 1;
      display: flex;
      position: absolute;
      top: 20px;
      left: 50px;
      .phone {
      margin-top: 6px;
      margin-left: 8px;
      width: 27.8px;
      height: 27.8px;
     }
    }
    
  }
  
  .right {
    .r-text {
      position: absolute;
      top: 20px;
      left: 120px;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #FFFFFF;
      opacity: 1;
    }
    width: 377;
    height: 82px;
    position: absolute;
    right: -70px;
   
  }
}
</style>